import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './auth_config';

export default new PublicClientApplication(msalConfig);
